String.prototype.startsWith||(String.prototype.startsWith=function(t,r){return r=r||0,this.substr(r,t.length)===t});



//////////////////
// WEBPACK FOOTER
// ./~/mdn-polyfills/String.prototype.startsWith.js
// module id = 971
// module chunks = 0